import { useIntl } from '@capsicum/common';
import { ActivityIndicator } from '@capsicum/common-web';
import { type ApprovedFooterPage, useShowApprovedFooter } from '@capsicum/features/regulations/shared';
import styled, { css, useTheme } from 'styled-components';

export type ApprovedFooterProps = {
	isGatewayPage?: boolean;
	page: ApprovedFooterPage;
};

export const ApprovedFooter = ({ isGatewayPage, page, ...props }: ApprovedFooterProps) => {
	const { $t } = useIntl();
	const { colors } = useTheme();

	const { approvedFooterDate, areSettingsLoading, shouldShowApprovedFooter } = useShowApprovedFooter(isGatewayPage);

	const date = approvedFooterDate(page);

	if (!shouldShowApprovedFooter(page) || areSettingsLoading) return null;

	return (
		<S.ApprovedFooter $isGatewayPage={isGatewayPage} {...props}>
			{areSettingsLoading ? (
				<S.LoaderWrapper>
					<ActivityIndicator color={colors.icons.brand.enabled} />
				</S.LoaderWrapper>
			) : (
				<>
					{$t('jurisdictionRequirements.approvedFooter.gb')}
					{date}
				</>
			)}
		</S.ApprovedFooter>
	);
};

namespace S {
	export const ApprovedFooter = styled.p<{ $isGatewayPage?: boolean }>`
		${({ theme }) => theme.fonts.text.text5};
		color: ${({ theme }) => theme.colors.text.main.enabled};
		padding: ${({ theme }) => theme.spacings.small};
		text-align: center;
		${({ $isGatewayPage }) =>
			$isGatewayPage &&
			css`
				padding-bottom: ${({ theme }) => theme.spacings.xxlarge};
			`};
	`;

	export const LoaderWrapper = styled.div`
		display: flex;
		justify-content: center;
	`;
}
